module.exports = __webpack_public_path__ + "static/pattern-geometric-36b629b5128c00e61f2786d91ce10e2a.png";